// extracted by mini-css-extract-plugin
module.exports = {"notificaton-container":"Notification_notificaton-container__iGOxQ","notification-btn":"Notification_notification-btn__Wg3zw"};